module.exports = __webpack_public_path__ + "static/media/sign-up-background.c4d8f988.png";